import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import SettingsSidebar from "@/user/components/SettingsSidebar";

export const Route = createFileRoute("/_panel/_settings")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex h-full flex-col">
      <div className="-m-6 h-full flex-1 sm:-mb-32">
        <div className="flex h-full">
          <SettingsSidebar />
          <div className="flex min-w-0 flex-1 flex-col px-6 pt-6">
            <Suspense fallback={<TableSkeleton />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
}
